import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { perfDashboardApi } from '../services/api';

// Perf Dashboard — renders a self-contained HTML SPA fetched (authenticated) from S3 via the LENS
// backend, inside a full-viewport sandboxed iframe. Intentionally NOT in the sidebar; reachable
// only by direct URL. Update the dashboard by re-uploading the HTML object to S3 (no LENS redeploy).
export default function PerfDashboard() {
  const [html, setHtml] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    let alive = true;
    perfDashboardApi
      .get()
      .then((res) => { if (alive) setHtml(res?.data?.html ?? ''); })
      .catch((err) => {
        if (alive) setError(err?.response?.data?.message || err.message || 'Failed to load the perf dashboard.');
      });
    return () => { alive = false; };
  }, []);

  if (error) {
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui,sans-serif' }}>
        <h2 style={{ margin: '0 0 6px' }}>Perf dashboard unavailable</h2>
        <p style={{ color: '#6b7280', maxWidth: 620, lineHeight: 1.5 }}>{error}</p>
      </div>
    );
  }
  if (html === null) {
    return <div style={{ padding: 24, color: '#6b7280', fontFamily: 'system-ui,sans-serif' }}>Loading perf dashboard…</div>;
  }
  return (
    <>
      <button
        type="button"
        onClick={() => navigate('/dashboard')}
        style={{
          position: 'fixed', top: 8, right: 12, zIndex: 51, fontSize: 12, padding: '4px 10px',
          border: '.5px solid rgba(0,0,0,.2)', borderRadius: 6, background: 'rgba(255,255,255,.92)',
          color: '#374151', cursor: 'pointer',
        }}
      >
        ← LENS
      </button>
      {/* No allow-same-origin: the S3-hosted HTML runs in an isolated opaque origin, so its
          scripts cannot read LENS's Auth0 tokens or reach the parent page. It can still run its
          own scripts and fetch its own (CORS-permitting) data. */}
      <iframe
        title="Perf Dashboard"
        srcDoc={html}
        sandbox="allow-scripts allow-popups allow-forms allow-downloads allow-modals"
        style={{ position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0, background: '#fff', zIndex: 50 }}
      />
    </>
  );
}
